<div
  class="gallery dark"
  [class.compact]="compact"
  [class.dark-background]="darkBackground"
  [class.blurred]="gallery['password_protected'] && showPasswordProtected"
  [class.has-asset]="!!gallery.teaser?.uuid"
  appInferredHover="gallery-{{ gallery.id }}"
  (mouseenter)="startHover()"
  (mousemove)="startHover()"
  (mouseleave)="endHover()"
  (onInferredHoverChange)="inferredHover.set($event)"
>
  <div class="background"></div>
  @if (gallery.teaser.uuid) {
    <div class="asset-container">
      <img
        [src]="gallery | galleryTeaserUrl: 600"
        [style.object-position]="gallery.teaser.uuid === gallery.cover?.uuid ? gallery.cover?.position : undefined"
        alt=""
        loading="lazy"
        [attr.data-picflow-hide]="true"
        #el
      />
    </div>
  } @else {
    <div class="gallery-asset-empty" alt="">
      <app-svg src="/assets/icons/96/image-dotted.svg"></app-svg>
    </div>
  }
  @if (hover() || inferredHover()) {
    <div class="gallery-interactions">
      <ng-content select="[contentOnHover]"></ng-content>
    </div>
  }
  <ng-content select="[contentAlways]"></ng-content>
  <div class="gallery-info">
    @if (publicMode) {
      <h3>{{ gallery.title || 'Untitled' }}</h3>
    } @else {
      <h3>{{ gallery.name || gallery.title || 'Untitled' }}</h3>
    }
    @if (!(gallery['password_protected'] && showPasswordProtected)) {
      <div class="meta">
        @if (gallery.enabled_gallery_statuses.length > 1) {
          <app-svg
            class="status-icon"
            [appTooltip]="gallery.status | galleryStatusName"
            src="/assets/icons/16/{{ gallery.status | galleryStatusIcon }}.svg"
            size="-1"
            [attr.color]="gallery.status | galleryStatusColor"
          ></app-svg>
        }
        @if (gallery.parent_gallery_id) {
          @if (gallery.public_access === 'no_access') {
            <app-svg src="/assets/icons/16/lock.svg"></app-svg>
          }

          <span>Sub-Gallery ⋅ </span>
        }
        <span>
          @if (gallery.total_assets_count === 1) {
            1 Asset
          } @else {
            {{ gallery.total_assets_count }} Assets
          }
        </span>
        @if (!gallery.parent_gallery_id) {
          <span> ⋅ {{ gallery.last_changed_at * 1000 | relativeTime }}</span>
        }
      </div>
    } @else {
      <div class="meta">
        <span>Protected Gallery</span>
      </div>
    }
  </div>
  @if (gallery['password_protected'] && showPasswordProtected) {
    <div class="lock">
      <app-svg src="/assets/icons/lock.svg"></app-svg>
    </div>
  }
  <div class="gallery-background"></div>
</div>
